<script lang="ts">
    import { _ } from 'svelte-i18n';
    import Switch from './Switch.svelte';
    import Checkbox from './Checkbox/Checkbox.svelte';

    export let label: string = '';
    export let checked: boolean = false;
</script>

<div class="filter-description-item">
    <Checkbox {label} bind:checked on:change />
</div>

<style>
    .filter-description-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: #e5f1fd;
        border-radius: 14px;
        padding: 1px 10px;
        /*margin: 2px 5px 2px 0;*/
        min-height: 26px;
        font-size: 15px;
    }
    :global(.checkbox-eye) {
        margin-right: 0;
    }
</style>
